import React, { useReducer, useState } from 'react';
import ordersReducer, { initialStateOrdersReducer } from 'reducers/Orders.reducer';
import {
  UPDATE_ORDERS,
  UPDATE_ISlOADING_ORDERS,
  SET_ORDER_TO_SHIPPING,
  OPEN_MODAL_CREATE_SHIPPING
} from 'actions/orders.actions';
import { getAllOrders } from 'services/ordersService';
import useUser from 'hooks/useUser';
import { AxiosError } from 'axios';
import { useHistory } from 'react-router-dom';
import { Pagination } from 'interfaces/pagination.interface';
import { IOrder, IOrderToShipping } from 'interfaces/order.interface';
import { IOrderPackages, IOrderShippingRequest } from 'interfaces/orderPackages.interface';
import { IShipping } from 'interfaces/shipping.interface';

const defaultPagination: Pagination = {
  limit: 10,
  page: 1
};

type State = {
  isLoadingOrders: boolean;
  totalOrders: number;
  orders: IOrder[];
  getOrders(page: number, limit: number, orderBy: string, order: string, search: string): void;
  orderToShipping: IOrderToShipping;
  setOrderToShipping(orderToShipping: IOrderToShipping): void;
  openModalCreateShipping: boolean;
  handleOpenModalCreateShipping(value: boolean): void;
  shipping: IShipping;
  updatePagination(state: Pagination): void;
  pagination: Pagination;
  orderPackages: IOrderPackages;
  setOrderPackages: React.Dispatch<React.SetStateAction<IOrderPackages>>;
  orderPackageShipping: IOrderShippingRequest;
  setOrderPackageShipping(state: IOrderShippingRequest): void;
};

interface Props {
  children: React.ReactNode;
}

const OrdersContext = React.createContext<State | undefined>(undefined);

export function OrdersContextProvider({ children }: Props) {
  const history = useHistory();

  const [pagination, setPagination] = useState<Pagination>(defaultPagination);
  const [orderPackages, setOrderPackages] = useState<IOrderPackages>({});
  const [orderPackageShipping, setOrderPackageShipping] = useState<IOrderShippingRequest>({
    cityCode: '',
    labelId: '',
    packages: [],
    serviceLevel: 0,
    delivery: '',
    orderId: 0,
    warehouseId: ''
  });

  const updatePagination = (state: Pagination) => {
    setPagination(state);
  };

  const [
    { orders, totalOrders, isLoadingOrders, openModalCreateShipping, shipping, orderToShipping },
    dispatch
  ] = useReducer(ordersReducer, initialStateOrdersReducer);
  const { jwt } = useUser();

  const getOrders = (page: number, limit: number, orderBy: string, order: string, search: string) => {
    dispatch({ type: UPDATE_ISlOADING_ORDERS, payload: true });
    getAllOrders({ jwt, pagination: { limit, page, orderBy, order, search } })
      .then((orderResponse) => {
        if (orderResponse) {
          dispatch({
            type: UPDATE_ORDERS,
            payload: {
              orders: orderResponse.orders,
              total: orderResponse.totalCount,
              totalPages: orderResponse.totalPages,
              isLoading: false
            }
          });
          updatePagination({
            ...pagination
          });
        }
      })
      .catch((err: AxiosError) => {
        if (err.response?.status === 403) {
          history.push(`/admin/connect-store`);
        }
      })
      .finally(() => {
        dispatch({
          type: UPDATE_ISlOADING_ORDERS,
          payload: false
        });
      });
  };

  const setOrderToShipping = (orderToShipping: IOrderToShipping) => {
    dispatch({ type: SET_ORDER_TO_SHIPPING, payload: orderToShipping });
  };

  const handleOpenModalCreateShipping = (value: boolean) => {
    dispatch({ type: OPEN_MODAL_CREATE_SHIPPING, payload: value });
  };
  return (
    <OrdersContext.Provider
      value={{
        isLoadingOrders: isLoadingOrders,
        orders: orders,
        totalOrders,
        getOrders,
        setOrderToShipping,
        openModalCreateShipping,
        handleOpenModalCreateShipping,
        updatePagination,
        pagination,
        shipping,
        orderPackages,
        setOrderPackages,
        orderToShipping,
        orderPackageShipping,
        setOrderPackageShipping
      }}
    >
      {children}
    </OrdersContext.Provider>
  );
}

export const useOrdersContext = () => {
  const context = React.useContext(OrdersContext);
  if (!context) {
    throw new Error('useOrderContext debe estar dentro del proveedor dentro de OrdersContextProvider');
  }
  return context;
};
